import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "common";
import { Observable } from "rxjs";
import {
  SigningSessionData,
  SigningStateData,
  SigningSubject,
  SigningSubjectKind,
} from "../domain/models/docusign-signing.model";

/** The DocuSign signing surface on the .NET 8 Customers service. */
@Injectable({
  providedIn: "root",
})
export class DocuSignSigningRemote {
  private readonly baseUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService
  ) {
    this.baseUrl = `${this.configService.environment.customersAPI.url}/docusign`;
  }

  /** Mints a fresh signing URL for the current customer; the URL is single-use and short-lived. */
  startSigningSession(subject: SigningSubject): Observable<SigningSessionData> {
    return this.http.post<SigningSessionData>(`${this.subjectUrl(subject)}/signing-session`, null, {
      headers: this.headers(),
    });
  }

  /** Where the caller stands on the subject's current envelope. */
  getSigningState(subject: SigningSubject): Observable<SigningStateData> {
    return this.http.get<SigningStateData>(`${this.subjectUrl(subject)}/signing-state`, {
      headers: this.headers(),
    });
  }

  private subjectUrl(subject: SigningSubject): string {
    return `${this.baseUrl}/${subject.kind === SigningSubjectKind.Loan ? "loans" : "applications"}/${subject.id}`;
  }

  /** No-cache, plus `hideLoader` so these calls never raise the global page blocker. */
  private headers(): HttpHeaders {
    return new HttpHeaders(this.configService.environment.cache.noCache).set("hideLoader", "true");
  }
}
